/**
 * Enables tween animations.
 */
export default class Tween {
	constructor(options, stepCallback, doneCallback) {
		const mergedOpts = { ...Tween.DEFAULTS, ...options }
		const { fps, from, to, duration, ease, type } = mergedOpts

		if (from == null || to == null) {
			throw new Error('Tween requires at least `from` and `to` options.')
		}

		this.from = from
		this.to = to
		this.duration = duration
		this.ease = ease
		this.type = type
		this.stepCallback = stepCallback
		this.doneCallback = doneCallback

		// Compute steps in this tween
		this.frames = (duration / 1000) * fps

		// Track anim step
		this.step = 0
	}

	getStep() {
		const step = this.ease(this.step / this.frames)

		switch (this.type) {
			case Tween.TYPE_VEC2:
				return [
					this.from[0] + (this.to[0] - this.from[0]) * step,
					this.from[1] + (this.to[1] - this.from[1]) * step
				]
			case Tween.TYPE_FLOAT:
			default:
				return this.from + (this.to - this.from) * step
		}
	}

	/**
	 * Computes the next step of the tween.
	 *
	 * @returns {Boolean} True if the tween is finished, else false.
	 * @memberof Tween
	 */
	next() {
		if (this.step < this.frames) {
			const value = this.getStep()
			this.stepCallback(value)
			this.step++
			return false
		}
		this.stepCallback(this.to)
		if (this.doneCallback) this.doneCallback(true)
		return true
	}

	/**
	 * Tween types
	 */

	static get TYPE_FLOAT() {
		return 'float'
	}
	static get TYPE_VEC2() {
		return 'vec2'
	}

	/**
	 * Default tween duration and easing function (linear).
	 *
	 * @readonly
	 * @static
	 * @memberof Tween
	 */
	static get DEFAULTS() {
		return {
			fps: 60,
			duration: 500,
			type: Tween.TYPE_FLOAT,
			ease: t => t
		}
	}
}
